import { s__ } from '~/locale';

export const CI_RESOURCES_PAGE_NAME = 'ci_resources';
export const CI_RESOURCE_DETAILS_PAGE_NAME = 'ci_resources_details';

export const CI_RESOURCES_BREADCRUMB = s__('CiCatalogComponent|CI/CD Catalog');
